module.exports = __webpack_public_path__ + "img/Yunxi.81dc8b8a.png";